// Bid & Offer Board helpers.
// An Offer Board auction is permanently 'live' - Sellers list Lots with a Sell
// Price (no Reserve Price) and Buyers make offers against them until the Lot is
// sold or expires.
export const OFFER_BOARD_GROUP_TITLE = 'Live Market Sales'

export function isOfferBoardAuction (auction) {
  if (!auction) {
    return false
  }
  return Boolean(auction.offerBoard) || auction.auctionType === 'offerBoard'
}

// A submitted Lot sits on an auction or on an Offer Board. Whichever it is, its
// id is what groups the Lot in the My Lots screens.
export function getLotListingId (lot) {
  let listing = (lot && (lot.offerBoard || lot.auction)) || null
  if (!listing) {
    return null
  }
  return typeof listing === 'string' ? listing : listing._id
}

export function isOfferBoardLot (lot) {
  if (!lot) {
    return false
  }
  return Boolean(lot.offerBoard) || isOfferBoardAuction(lot.auctionData)
}

export function offerHistory (offer) {
  if (!offer) {
    return []
  }
  let counters = Array.isArray(offer.counters) ? offer.counters : []
  if (!counters.length && offer.counterCents) {
    counters = [{ cents: offer.counterCents, party: offer.counterParty, at: offer.respondedAt }]
  }
  return [{ counter: false, cents: offer.cents, party: 'buyer', at: offer.createdAt }].concat(
    counters.map(one => ({
      counter: true,
      cents: one.cents,
      party: one.party || 'seller',
      at: one.at
    }))
  )
}

export function offerPartyLabel (party, viewerParty) {
  if (party === viewerParty) {
    return 'you'
  }
  return party === 'buyer' ? 'buyer' : 'seller'
}


export function isOfferBoardListing (lot) {
  return Boolean(lot) && !lot.auction && Boolean(lot.offerBoard)
}


export function isOfferBoardNumber (number) {
  return /^OB\d+$/i.test(`${number || ''}`)
}

// A Lot belongs to one category of the board, the one the Seller picked.
export function getOfferBoardCategory (offerBoard, categoryTitle) {
  let categories = (offerBoard && offerBoard.categories) || []
  if (!categoryTitle) {
    return categories[0]
  }
  return categories.find(category => {
    return category.kindData && category.kindData.title === categoryTitle
  }) || categories[0]
}

export function offerBoardToAuction (offerBoard, categoryTitle) {
  let category = getOfferBoardCategory(offerBoard, categoryTitle) || {}
  return {
    _id: offerBoard._id,
    offerBoard: true,
    title: offerBoard.title,
    number: offerBoard.number,
    searchNumber: offerBoard.searchNumber,
    state: offerBoard.state,
    // one entry per stock type the board holds, with its own listing expiry
    categories: offerBoard.categories || [],
    // the Lot form works with one category at a time, the chosen one
    kindData: category.kindData,
    listingExpiryDays: category.listingExpiryDays,
    location: offerBoard.location || { state: [] },
    lotCount: offerBoard.lotCount || 0,
    createdAt: offerBoard.createdAt,
    // the list sorts and groups on liveAt, a board runs from the day it opened
    liveAt: offerBoard.createdAt,
    // a board carries no tags and its lots are not loaded into this list, both
    // are read by the Upcoming filters
    auctionTags: [],
    lotData: []
  }
}

export function withOfferBoards (auctions = [], offerBoards = []) {
  if (!offerBoards.length) {
    return auctions
  }
  return offerBoards.map(offerBoardToAuction).concat(auctions.filter(auction => !isOfferBoardAuction(auction)))
}

// A board holds several categories at once, so it belongs to each of them
export function hasOfferBoardCategory (auction, stockType) {
  return (auction.categories || []).some(category => {
    return category.kindData && category.kindData.type === stockType
  })
}

// On the Offer Board there is no Reserve Price - the Start Price field is used
// as the Sell Price.
export function getStartPriceTitle (auction, bidding) {
  const perKg = bidding === 'kg'
  if (isOfferBoardAuction(auction)) {
    return perKg ? 'Sell Price (¢/kg)' : 'Sell Price ($/head)'
  }
  return perKg ? 'Start Price (¢/kg)' : 'Start Price ($/head)'
}
